import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

// Layout das rotas públicas (Reviter marketplace + storefronts):
// `/`, `/catalogo`, `/produto/:id`, `/carrinho`, `/checkout`, auth,
// e `/fornecedor/:slug/*` whitelabel.
const PublicLayout = () => (
  <div className="min-h-screen bg-app-bg flex flex-col">
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default PublicLayout;
